import React from 'react'

function CC_program_details() {
  return (
    <div>
    
    {/* --------------------Mobile view----------------- */}
    <div className='d-sm-block d-md-none'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-12 detail_1stcomp_img'>
                <div className='Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-6'>Soar Beyond Limits in Cloud Computing!</h1>
                    <p className='py-2'>Dive into the future with our Cloud Computing program. Master the skies of technology. Enrol now for a journey that shapes brilliance and ensures a bright tomorrow!</p>
                </div>
                <div className='mt-4 Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-4'>Overview</h1>
                    <p className='py-2'>Discover the ever-changing realm of cloud computing with our all-inclusive course! Learn about Azure services, have a thorough understanding of Cloud Fundamentals, and become an expert in networking. Gain real experience with projects that range from Azure Storage to Security and Monitoring. Improve your knowledge of Azure principles, backup and recovery, and other topics. This planned curriculum, which combines academic knowledge with practical application, will help you get ready for the future of IT. Enroll today to start a journey via Azure and Cloud Computing that will change your life and open doors to efficiency and innovation.</p>
                </div>
            </div>
            <div className='col-md-12'>
                <div>
                <div className=' Details_container shadow-lg px-3 py-4'>
                <h1 className='mobile_view_Details_text text-center  pb-2 border-bottom'>Cloud Computing</h1>
                  <div className='mobile_view_Details_text'>
                    <ul className='pt-2'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>

    {/* --------------------Desktop View--------------- */}
    <div className='d-none d-md-block'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-8 detail_1stcomp_img'>
                <div className='pt-3 Program_details_1stcomp_text'>
                    <h1 className='display-6'>Soar Beyond Limits in Cloud Computing!</h1>
                    <p className='py-4'>Dive into the future with our Cloud Computing program. Master the skies of technology. Enrol now for a journey that shapes brilliance and ensures a bright tomorrow!</p>
                </div>
                <div className='mt-3 Program_details_1stcomp_text'>
                    <h1 className='display-3'>Overview</h1>
                    <p className='py-4'>Discover the ever-changing realm of cloud computing with our all-inclusive course! Learn about Azure services, have a thorough understanding of Cloud Fundamentals, and become an expert in networking. Gain real experience with projects that range from Azure Storage to Security and Monitoring. Improve your knowledge of Azure principles, backup and recovery, and other topics. This planned curriculum, which combines academic knowledge with practical application, will help you get ready for the future of IT. Enroll today to start a journey via Azure and Cloud Computing that will change your life and open doors to efficiency and innovation.</p>
                </div>
            </div>
            <div className='col-md-4'>
                <div>
                <div className=' Details_container shadow-lg px-3 pt-4 pb-5'>
                <h1 className='Details_text text-center  pb-4 pt-3 border-bottom'>Cloud Computing</h1>
                  <div className='Details_text '>
                    <ul className='pt-4'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default CC_program_details
